// extracted by mini-css-extract-plugin
export default {"modal":"ProfileModal_modal__pPA9d","profileModalBody":"ProfileModal_profileModalBody__sbvsr","button":"ProfileModal_button__eu5un","buttonLogout":"ProfileModal_buttonLogout__1lrqX"};